import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import AddonsAndUpgradesBlockData from "../../../Models/Content/AddonsAndUpgradesBlockData";
import AddonsAndUpgrades from "./AddonsAndUpgrades";

export default class AddonsBlock extends EpiComponent<AddonsAndUpgradesBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["addons-and-upgrades-block"];

    return (
      <div className={cssClasses.join(" ")}>
        <AddonsAndUpgrades iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
